/**
 * An AI Service's analytics series (task 1255), read through the app's
 * standard service layer from `GET /endpoints/:id/analytics` (task 1254).
 *
 * The query key carries the range and environment, so moving the time range
 * picker or the environment filter is a new read and switching back is a cache
 * hit. `enabled` is the caller's: the Analytics tab is the only reader, and it
 * is not mounted at all while `innovate.fe.analytics-tab` is off.
 */
import { useQuery } from '@tanstack/react-query';
import { endpointAnalyticsApi } from '@/services/api';
import type { EndpointAnalyticsQuery } from '@/types/analytics';

export const endpointAnalyticsQueryKey = (endpointId: string | undefined, query: EndpointAnalyticsQuery) =>
  ['endpoint-analytics', endpointId, query.from, query.to, query.environment ?? null] as const;

export const useEndpointAnalytics = (endpointId: string | undefined, query: EndpointAnalyticsQuery) =>
  useQuery({
    queryKey: endpointAnalyticsQueryKey(endpointId, query),
    queryFn: () => endpointAnalyticsApi.get(endpointId!, query).then((res) => res.data.data),
    enabled: !!endpointId,
  });
